import React from "react";
import styled from "styled-components";
import screenSizes from "../../../utils/screenSizes";
import {injectIntl, changeLocale} from "gatsby-plugin-intl";

const LanguageSwitcherDesktop = ({intl}) => {
  // Get the current language code
  const currentLanguageCode = intl.language;

  return (
    <Languages>
      {['en', 'uk']?.map((lang, index, array) => (
        <React.Fragment key={lang}>
          {lang === currentLanguageCode ? (
            <span>{lang?.toString()?.toUpperCase()?.replace('UK', 'UA')}</span>
          ) : (
            <button onClick={() => changeLocale(lang)}>{lang?.toString()?.toUpperCase()?.replace('UK', 'UA')}</button>
          )}
          {index < array.length - 1 && <> / </>}
        </React.Fragment>
      ))}
    </Languages>
  )
}

export default injectIntl(LanguageSwitcherDesktop)

const Languages = styled.div `
  flex: 1;
  text-align: right;
  
  color: var(--color-white);
  font-size: 30px;
  font-weight: 100;
  text-transform: uppercase;
  
  span {
    font-weight: 600;
  }

  @media (min-width: ${screenSizes.mobile}) and (max-width: ${screenSizes.tablet}) {
    font-size: 26px;
  }

  @media (max-width: ${screenSizes.mobile}) {
    font-size: 18px;
    margin-right: 15px;
  }
`
